(ns motorsaif.shared.ops
  (:require
   [goog.string :refer [format]]
   [motorsaif.time :as time]
   [taoensso.encore :as encore]))

(defn last-msg [thread]
  (:message (last (sort-by (comp :date-time/created :message) < thread))))

(defn time-remaining-text
  "Calculate time remaining until deadline and return display text.
   Returns {:text '4h left' :class 'left'} or {:text '2h late' :class 'late'}"
  [last-status status-data]
  (when (and last-status status-data)
    (let [max-hours (get-in status-data [:time :max])
          last-date (:date last-status)

          deadline (when last-date
                     (time/date-plus
                      last-date
                      :hours max-hours))

          time-remaining (when deadline
                          (- deadline (time/date)))

          abs-remaining (when time-remaining (Math/abs time-remaining))
          hours (when abs-remaining (Math/floor (/ abs-remaining (encore/ms :hours 1))))
          minutes (when abs-remaining (Math/floor (/ (mod abs-remaining (encore/ms :hours 1)) (encore/ms :minutes 1))))]

      (when time-remaining
        (cond
          (pos? time-remaining)
          {:text (cond
                   (>= hours 24) (format "%dd left" (Math/floor (/ hours 24)))
                   (>= hours 1) (format "%dh left" hours)
                   (>= minutes 1) (format "%dm left" minutes)
                   :else "Due now")
           :class "left"}

          (neg? time-remaining)
          {:text (cond
                   (>= hours 24) (format "%dd late" (Math/floor (/ hours 24)))
                   (>= hours 1) (format "%dh late" hours)
                   (>= minutes 1) (format "%dm late" minutes)
                   :else "Just late")
           :class "late"}

          :else
          {:text "Due now" :class "due"})))))

(def categories
  [
   {:title "Leads"
    :desc "New conversations & inquiries"
    :category :leads
    :icon [:i.fa-solid.fa-user-plus]
    }
   {:title "Past Deadline"
    :desc "Overdue tasks need attention"
    :category :past-deadline
    :icon [:i.fa-solid.fa-triangle-exclamation]
    }
   {:title "Urgent"
    :desc "Approaching deadline soon"
    :category :urgent
    :icon [:i.fa-solid.fa-triangle-exclamation]
    }
   {:title "Needs Attention"
    :desc "Customer waiting for response"
    :category :attention
    :icon [:i.fa-solid.fa-triangle-exclamation]
    }
   {:title "In Progress"
    :desc "Active repairs & sourcing"
    :category :progress
    :icon [:i.fa-solid.fa-gear]
    }
   {:title "Waiting on Customer"
    :desc "Payments & approvals needed"
    :category :waiting
    :icon [:i.fa-solid.fa-clock]
    }
   {:title "All Conversations"
    :desc "Complete overview of requests"
    :category :all
    :icon [:i.fa-solid.fa-list]}])
